<template>
    <div id="page-cheat-detail">
        <vs-row vs-w="12">
            <vs-col vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-tabs :value="index_tab_1">
                    <vs-tab label="Trùng giây" @click="changeTab(0)"></vs-tab>
                    <vs-tab label="Copy" @click="changeTab(1)">
                        <vs-tabs :value="index_tab_2">
                            <vs-tab label="Copy" @click="changeTab(1)"></vs-tab>
                            <vs-tab label="Lệch 10s" @click="changeTab(11)"></vs-tab>
                            <vs-tab label="Lệch 15s" @click="changeTab(12)"></vs-tab>
                            <vs-tab label="Lệch 20s" @click="changeTab(13)"></vs-tab>
                            <vs-tab label="Lệch 30s" @click="changeTab(14)"></vs-tab>
                            <vs-tab label="Lệch 60s" @click="changeTab(15)"></vs-tab>
                            <vs-tab label="Lệch 120s" @click="changeTab(16)"></vs-tab>
                        </vs-tabs>
                    </vs-tab>
                    <vs-tab label="Cỏ tay" @click="changeTab(24)">
                        <vs-tabs :value="index_tab_2">
                            <vs-tab label="Cỏ tay" @click="changeTab(2)"></vs-tab>
                            <vs-tab label="Lệch 1s" @click="changeTab(21)"></vs-tab>
                            <vs-tab label="Lệch 2s" @click="changeTab(22)"></vs-tab>
                            <vs-tab label="Lệch 3s" @click="changeTab(23)"></vs-tab>
                            <vs-tab label="Lệch 5s" @click="changeTab(24)"></vs-tab>
                            <vs-tab label="Lệch 30s" @click="changeTab(25)"></vs-tab>
                            <vs-tab label="Lệch 60s" @click="changeTab(26)"></vs-tab>
                        </vs-tabs>
                    </vs-tab>
                    <vs-tab label="Cỏ ip" @click="changeTab(3)"></vs-tab>
                    <vs-tab label="Cỏ máy" @click="changeTab(4)"></vs-tab>
                </vs-tabs>
            </vs-col>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="6" vs-type="flex" vs-justify="flex-start">
                <vs-button disabled :color="p.className" type="line" :key="indexPlayer"
                    v-for="(p, indexPlayer) in player_info">
                    {{ p.txt }}: {{ p.val }}
                </vs-button>
            </vs-col>
        </vs-row>
        <div class="vx-card">
            <vs-row vs-w="12">
                <vs-col class="py-4" vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="12" vs-sm="12"
                    vs-xs="12">
                    <ul class="centerx">
                        <li :key="indexmem" v-for="(m, indexmem) in mem_count" style="float:left; margin-left: 20px;">
                            {{ m.mem + ' (' + m.count + ')' }}
                        </li>
                    </ul>
                </vs-col>
            </vs-row>
            <vs-table stripe pagination :max-items="itemsPerPage" :data="cheatDetail">
                <template slot="header">

                    <div class="flex-grow">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div
                                class="p-3 border border-solid d-theme-border-grey-light rounded-full cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">
                                    {{ itemsPerPage }}
                                </span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item :key="ipp" v-for="ipp in [100, 200, 300]"
                                    @click="itemsPerPage = ipp"><span>{{ ipp }}</span></vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                    <vs-input placeholder="Member" v-model="searchValue" />
                    <vs-checkbox icon="invert_colors" color="rgb(38, 187, 174)" v-model="all">Ẩn rác</vs-checkbox>
                    <vs-select v-model="filterOdds"
                        v-if="cheat_id == 2 || cheat_id == 21 || cheat_id == 22 || cheat_id == 23 || cheat_id == 24 || cheat_id == 25 || cheat_id == 26 || cheat_id == 3 || cheat_id == 4">
                        <vs-select-item value="0" text="Không lọc giá" />
                        <vs-select-item value="3" text="Lọc 3 giá" />
                        <vs-select-item value="4" text="Lọc 4 giá" />
                        <vs-select-item value="5" text="Lọc 5 giá" />
                    </vs-select>
                    <vs-button class="ml-1" color="primary" @click="createReport">Tạo báo cáo</vs-button>
                    <date-range-picker @date-change="onDateFilterChange"
                        :initDate="{ from: dateFilterFrom, to: dateFilterTo }" />
                </template>
                <template slot="thead">
                    <vs-th :key="h.id" v-for="h in header">
                        {{ h.title }}
                    </vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr
                        :class="data[indextr - 1] && data[indextr - 1].key != data[indextr].key ? 'bet_key_border' : null"
                        :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :key="h.id" v-for="h in header" :data="data[indextr][h.field]">
                            <p
                                :class="tr.bet_key && h.field == 'member_name' ? 'bet_key' : tr.dup && h.field == 'member_name' ? 'bet_dup' : null">
                                <template v-if="h.render">
                                    {{ h.render(data[indextr]) }}
                                </template>
                                <template v-else>
                                    {{ data[indextr][h.field] }}
                                </template>
                            </p>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<style lang="css">
#page-cheat-detail .con-tab.vs-tabs--content {
    padding: 1px;
}

#page-cheat-detail .con-vs-chip {
    top: 0px;
    border-radius: 20px;
    color: #000;
    min-height: 20px;
    min-width: 20px;
}

#page-cheat-detail .bet_key_border {
    border-top: 10px solid #ddd;
}

#page-cheat-detail .bet_key {
    color: rgb(255 0 22);
    /* color: #f02849; */
}

#page-cheat-detail .bet_dup {
    color: rgb(0 97 255);
    /* color: #216fdb; */
}

#page-cheat-detail .vs-tabs--li button.vs-tabs--btn {
    padding: 7px;
}

#page-cheat-detail .vs-button:disabled {
    opacity: 1;
}
</style>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import vSelect from 'vue-select';
import moment from "moment";
import DateRangePicker from '@/components/DateRangePicker';

export default {
    data() {
        return {
            header: [
                { title: "Tên thành viên", field: "member_name", render: function (data) { return data.member_name.toUpperCase(); } },
                { title: "Ngày", field: "bet_time", render: function (data) { return moment(data.bet_time).format("DD-MM-YYYY|HH:mm:ss") } },
                { title: "IP", field: "bet_ip" },
                { title: "Trận", field: "bet_match" },
                { title: "Loại", field: "bet_type" },
                { title: "Chọn", field: "bet_choice", render: function (data) { return `${data.bet_choice} ${data.bet_handicap} ${data.bet_favorite}` } },
                { title: "Odds", field: "bet_odds" },
                { title: "Stake", field: "bet_stake" },
                { title: "Status", field: "bet_status" },
                { title: "Sàn", field: "board_id", render: function (data) { return data.board_id == 1 ? "ibet" : data.board_id == 2 ? "sbobet" : "unknown"; } },
            ],
            cheatDetailAll: [],
            cheatDetail: [],
            // cheatCount: [],
            member_name: '',
            dateFilterFrom: null,
            dateFilterTo: null,
            cheat_id: null,
            all: true,
            index_tab_1: 0,
            index_tab_2: 0,
            searchValue: '',
            mem_count: [],
            player_info: [],
            itemsPerPage: 200,
            filterOdds: 0
        }
    },
    watch: {
        // cheatCount: function(value){
        //     let vm = this;
        //     this.$nextTick(() => {
        //         // this.index_tab_1 = 0;
        //         value.forEach(function(val, index){
        //             if(val.cheat_id == vm.cheat_id){
        //                 vm.index_tab_1 = index;

        //                 val.child.forEach(function(v, i){
        //                     if(v.cheat_id == vm.cheat_id) vm.index_tab_2 = i;
        //                 });
        //             }
        //         });
        //     });
        // },
        // cheat_id: function(val){
        //     if(val == 2 || val == 21 || val == 22 || val == 23 || val == 24 || val == 4) this.all = false;
        // },
        cheatDetailAll: function (val) {
            console.log('cheatDetailAll');
            this.cheatDetail = this.all ? this.cheatDetailAll.filter(bet => bet.dup) : this.cheatDetailAll;
        },
        all: function (val) {
            this.cheatDetail = val ? this.cheatDetailAll.filter(bet => bet.dup) : this.cheatDetailAll;
        },
        filterOdds: function (val) {
            this.all == true;
            if (val == 0) {
                this.cheatDetail = this.cheatDetailAll;
            } else {
                console.log('filterOdds');
                var groupByKey = this.cheatDetailAll.reduce(function (r, a) {
                    r[a.key] = r[a.key] || [];
                    r[a.key].push(a);
                    return r;
                }, Object.create(null));
                var res = [];
                Object.values(groupByKey).forEach(gby => {
                    var betKey = gby.find(obj => {
                        return obj.bet_key == true;
                    });
                    var keyOdds = betKey.bet_odds;

                    var betValue = gby.filter(obj => {
                        if (obj.bet_key != true) {
                            if ((obj.bet_odds * keyOdds) < 0) {
                                var ko = Math.abs(keyOdds);
                                var vo = Math.abs(obj.bet_odds);
                                if (Math.abs(vo - ko).toFixed(2) <= parseFloat("0.0" + val)) {
                                    return obj;
                                }
                            }
                        }
                    });
                    betValue = betValue.map(a => a.bet_odds);
                    if (betValue.length > 0) {
                        var odds = [];
                        gby.map(obj => {
                            if (obj.bet_key) {
                                res.push(obj);
                            } else {
                                if (!odds.includes(obj.bet_odds) && betValue.includes(obj.bet_odds)) {
                                    res.push(obj);
                                    odds.push(obj.bet_odds);
                                }
                            }
                        });
                    }
                });
                this.cheatDetail = res;
            }

        },
        searchValue: function (val) {
            if (val != '') {
                let all = this.cheatDetailAll;
                let block = [];
                let res = [];
                all.forEach(function (bet, index) {
                    if (bet.bet_key || (bet.member_name).toLowerCase() == val.toLowerCase()) {
                        block.push(bet);
                    }

                    if (!all[index + 1] || (all[index + 1] && all[index + 1].key != bet.key)) {
                        if (block.length > 1) {
                            res = res.concat(block);
                        }
                        block = [];
                    }
                });
                this.cheatDetail = res;
            } else {
                this.cheatDetail = this.all ? this.cheatDetailAll.filter(bet => bet.dup) : this.cheatDetailAll;
            }
        }
    },
    beforeRouteUpdate(to, from, next) {
        let member_name = to.query.member_name;
        let bet_from = to.query.from;
        let bet_to = to.query.to;
        let cheat_id = to.query.cheat_id;
        let like = to.query.like;

        this.fetchCheatDetail(member_name, bet_from, bet_to, cheat_id, like);
        next();
    },
    methods: {
        fetchPlayerInfo() {
            let vm = this;
            this.$http.get("cheats/player-info?member_name=" + vm.member_name + "&from=" + vm.dateFilterFrom + "&to=" + vm.dateFilterTo).then((res) => {
                vm.player_info = res.data.data;
            });
        },
        // fetchCheatCountOne() {
        //     let vm = this;
        //     this.$http.get("cheats/count-one?member_name="+vm.member_name+"&from="+vm.dateFilterFrom+"&to="+vm.dateFilterTo).then((res) => {
        //         vm.cheatCount = res.data.data;
        //     });
        // },
        fetchCheatDetail(member_name, from, to, cheat_id, like) {
            let vm = this;
            vm.cheatDetailAll = [];
            vm.cheatDetail = [];
            vm.filterOdds = 0;

            this.$http.get("cheats/detail?member_name=" + member_name + "&from=" + from + "&to=" + to + "&cheat_id=" + cheat_id + "&like=" + like).then((res) => {
                vm.cheatDetailAll = res.data.data;
                vm.cheatDetail = res.data.data.filter(bet => bet.dup);

                let member_names = res.data.data.map(a => a.member_name);
                let member_value = member_names.filter(a => a != member_name);
                vm.mem_count = vm.count_duplicate(member_value, cheat_id);

                vm.all = (cheat_id == 2 ||
                    cheat_id == 21 ||
                    cheat_id == 22 ||
                    cheat_id == 23 ||
                    cheat_id == 24 ||
                    cheat_id == 25 ||
                    cheat_id == 26 ||
                    cheat_id == 4) ? false : true;
                if (cheat_id == 24) {
                    vm.filterOdds = 3;
                }
            });
        },
        count_duplicate(a, cheat_id) {
            let counts = {}
            let res = [];
            for (let i = 0; i < a.length; i++) {
                if (counts[a[i]]) {
                    counts[a[i]] += 1
                } else {
                    counts[a[i]] = 1
                }
            }
            for (let prop in counts) {
                if (cheat_id == 14 ||cheat_id == 15 ||cheat_id == 16 || cheat_id == 13) {
                    if (counts[prop] >= 7) {
                        res.push({
                            mem: prop,
                            count: counts[prop]
                        });
                    }
                } else if (cheat_id == 12) {
                    if (counts[prop] >= 5) {
                        res.push({
                            mem: prop,
                            count: counts[prop]
                        });
                    }
                } else {
                    if (counts[prop] >= 4) {
                        res.push({
                            mem: prop,
                            count: counts[prop]
                        });
                    }
                }
            }
            return res;
        },
        changeTab(cheat_id) {
            let vm = this;
            if (this.cheat_id != cheat_id) {
                this.cheat_id = cheat_id;
                let like = !this.$router.currentRoute.query.like ? '' : '&like=' + this.$router.currentRoute.query.like;
                this.$router.push({ path: "/cheats/detail?member_name=" + this.member_name + "&from=" + this.dateFilterFrom + "&to=" + this.dateFilterTo + "&cheat_id=" + cheat_id + like });

                cheat_id = cheat_id + '';
                if (cheat_id.length == 1) {
                    this.index_tab_1 = cheat_id;
                    this.index_tab_2 = 0;
                } else {
                    this.index_tab_1 = cheat_id.substr(0, 1);
                    this.index_tab_2 = cheat_id.substr(1, 1);
                }

            }
        },
        onDateFilterChange(data) {
            this.dateFilterFrom = data.fromDate;
            this.dateFilterTo = data.toDate;

            let query = Object.assign({}, this.$route.query);
            query.from = data.fromDate;
            query.to = data.toDate;

            // this.fetchCheatCountOne();
            this.fetchPlayerInfo();
            this.$router.push({ path: "/cheats/detail", query: query });
        },
        createReport() {
            let vm = this;
            console.log(window.location.origin);
            Swal.fire({
                title: "Nhập nguyên nhân gian lận.",
                input: "text",
                showCancelButton: true,
                confirmButtonText: "Tạo link",
                showLoaderOnConfirm: true,
                preConfirm: async (reason) => {
                    try {
                        const response = await vm.$http.post("report_ai", {
                            "reason": reason,
                            "member_name": vm.member_name,
                            "from": vm.dateFilterFrom,
                            "to": vm.dateFilterTo,
                            "cheat_id": vm.cheat_id,
                            "all": vm.all == true ? 1: 0,
                            "filterOdds": vm.filterOdds,
                            "member_value": vm.searchValue
                        });
                        console.log(response);
                        if (response.status != 200) {
                            return Swal.showValidationMessage("Báo kỹ thuật kiểm tra");
                        }
                        return response.data;
                    } catch (error) {
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    }
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then((result) => {
                console.log(result);
                if (result.isConfirmed) {
                    Swal.fire({
                        title: "Tạo báo cáo thành công",
                        icon: "success",
                        html: `Truy cập đường dẫn <a target="_blank" href="${window.location.origin + result.value.data.link}" autofocus>${window.location.origin + result.value.data.link}</a> <br/> Mật khẩu: <b>${result.value.data.password}</b> để xem báo cáo,`,
                        showCloseButton: true,
                        showCancelButton: true,
                        focusConfirm: false,
                        confirmButtonText: `Hoàn Thành`
                    });
                }
            });
        }
    },
    components: {
        DateRangePicker
    },
    created() {
        this.member_name = this.$route.query.member_name;
        this.dateFilterFrom = this.$route.query.from;
        this.dateFilterTo = this.$route.query.to;
        this.cheat_id = this.$route.query.cheat_id;

        if (this.cheat_id.length == 1) {
            this.index_tab_1 = this.cheat_id;
            this.index_tab_2 = 0;
        } else {
            this.index_tab_1 = this.cheat_id.substr(0, 1);
            this.index_tab_2 = this.cheat_id.substr(1, 1);
        }
        // this.fetchCheatCountOne();
        this.fetchPlayerInfo();
        this.fetchCheatDetail(this.member_name, this.dateFilterFrom, this.dateFilterTo, this.cheat_id, this.$route.query.like);
    }
};
</script>

<style>
.swal2-container {
    z-index: 99999;
}
</style>
